import { render, staticRenderFns } from "./AddVisitObject.vue?vue&type=template&id=21d27dd4&scoped=true&"
import script from "./AddVisitObject.vue?vue&type=script&lang=js&"
export * from "./AddVisitObject.vue?vue&type=script&lang=js&"
import style0 from "./AddVisitObject.vue?vue&type=style&index=0&id=21d27dd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d27dd4",
  null
  
)

export default component.exports